function descriptionShave() {
	const hero__description = document.querySelector('.collection-hero__description-text');

	if (hero__description) {
		var maxHeight = hero__description.dataset.max;
		var height = hero__description.offsetHeight;

		function trimSection() {
			button.innerText = '... Read more';
			button.classList.add('text-hidden');
			hero__description.style.maxHeight = maxHeight - 4 + 'px';
		}

		function openSection() {
			button.innerText = '... Read less';
			button.classList.remove('text-hidden');
			hero__description.style.maxHeight = 'none';
		}

		if (height > maxHeight) {
			var button = document.createElement('button');
			button.classList.add(hero__description.dataset.fontSize);

			document.querySelector('.collection-hero__description').appendChild(button);

			trimSection();

			button.addEventListener('click', function (event) {
				if (button.classList.contains('text-hidden')) {
					openSection();
				} else {
					trimSection();
				}
			});
		}
	}
}

descriptionShave();
document.addEventListener('shopify:section:load', descriptionShave);

// function imageZoomInit() {
// 	const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

// 	if (vw > 750) {
// 		var options2 = {
// 			fillContainer: true,
// 			offset: { vertical: 0, horizontal: 10 },
// 			zoomPosition: 'original',
// 		};

// 		const zoomContainers = document.querySelectorAll('.media-zoom-img');

// 		zoomContainers.forEach((container) => {
// 			const img = container.querySelector('img');

// 			img.onload = function () {
// 				console.log(img, img.naturalWidth);
// 			}
// 			// new ImageZoom(container, options2);
// 		});
// 	}
// }
// imageZoomInit();

// window.onresize = imageZoomInit;
// document.addEventListener('shopify:section:load', imageZoomInit);
